var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketExtremeBigMoveDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.57 34.444l-7.304-7.305a1.76 1.76 0 010-2.568 1.76 1.76 0 012.568 0L26 28.737V7.622c0-1.027.856-1.826 1.826-1.826 1.028 0 1.827.799 1.827 1.826v21.115l4.223-4.166a1.76 1.76 0 012.568 0 1.76 1.76 0 010 2.568l-7.305 7.305a1.76 1.76 0 01-2.568 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.734 12.627l-7.305-7.304a1.76 1.76 0 00-2.568 0l-7.305 7.304a1.76 1.76 0 000 2.568 1.76 1.76 0 002.568 0l4.223-4.165v3.636H14V11.03l4.166 4.165a1.76 1.76 0 002.568 0 1.76 1.76 0 000-2.568zM14 17.797h-3.653v3.13H14v-3.13zm0 6.26h-3.653v3.13H14v-3.13zm0 6.261v1.826a1.839 1.839 0 01-1.826 1.827 1.803 1.803 0 01-1.827-1.826v-1.827H14z"
  })));
}
export default SvgMarketExtremeBigMoveDown;